import { CaretLeft } from '@phosphor-icons/react';

import {
  CategoryBudgetCompactRow,
  CategoryBudgetFocusCard,
} from './CategoryBudgetFocusCard';
import { formatEUR } from '../../utils/money';
import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

function resolveCategoryId(category) {
  return category?.category_id || category?.id || category?.pot_id || null;
}

/**
 * Camada 3 — painel de foco (mobile inline ou coluna direita em md+).
 */
export function BudgetCategoryFocusPanel({
  group,
  category,
  siblings = [],
  onBack,
  onSelectSibling,
  showBack = true,
  className,
}) {
  if (!group || !category) return null;

  const categories = [
    category,
    ...siblings.filter((c) => resolveCategoryId(c) !== resolveCategoryId(category)),
  ];
  const defined = Number(group.categories_budget_sum_eur ?? group.budget_eur ?? 0);
  const groupLabel = group.name || pt.categories.form.noGroup;
  const amountStr = formatEUR(defined);
  const titleSuffix = pt.budget.category.focusGroupTitle
    .replace('{amount}', amountStr)
    .replace('{count}', String(categories.length))
    .slice(amountStr.length);

  return (
    <div
      className={cn(
        'flex flex-col gap-space-4 rounded-ds-lg border border-sage-border bg-card p-space-4 shadow-[0_6px_16px_rgb(var(--glass-shadow)/0.08)] wide:p-space-5',
        className,
      )}
      data-testid="budget-category-focus-panel"
    >
      <div className="flex items-center gap-space-3">
        {showBack ? (
          <button
            type="button"
            onClick={onBack}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-ds-md bg-muted"
            aria-label={pt.budget.category.focusBack}
          >
            <CaretLeft className="h-[18px] w-[18px] text-muted-foreground" aria-hidden />
          </button>
        ) : null}
        <div className="min-w-0 flex-1">
          <p className="type-section text-sage-on-tint">{groupLabel}</p>
          <p className="mt-space-1 leading-[1.15] tracking-tight">
            <span className="type-display-metric font-semibold text-foreground">{amountStr}</span>
            <span className="type-body-sm text-muted-foreground">{titleSuffix}</span>
          </p>
        </div>
      </div>

      <CategoryBudgetFocusCard category={category} group={group} />

      {siblings.length > 0 ? (
        <div>
          <p className="type-section px-0.5 pb-space-1 text-muted-foreground">
            {pt.budget.category.otherInGroup}
          </p>
          {siblings.map((cat) => (
            <CategoryBudgetCompactRow
              key={cat.pot_id || cat.category_id}
              category={cat}
              onSelect={onSelectSibling}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

export { resolveCategoryId };
